import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      gap: '20px',
      width: 'available',
      '@media (max-width: 768px)': {
        flexDirection: 'column'
      }
    },
    dashboard: {
      '@media (max-width: 1279px)': {
        flexDirection: 'column'
      }
    },
    col: {
      width: '50%',
      '@media (max-width: 768px)': {
        width: 'auto'
      }
    },
    coldashboard: {
      width: '50%',
      '@media (max-width: 1279px)': {
        width: 'auto'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
